import { useSnackbar } from "notistack";
import React, { useRef, useState, useEffect } from "react";
import { GrFormClose } from "react-icons/gr";
function CustomUploadField({
  style,
  title,
  onChange,
  accept = ".pdf",
  isDownloadFileRequired = false,
  onClickRemove,
  value,
}) {
  const [file, setFile] = useState({});
  const [fileName, setFileName] = useState("");
  const fontStyle = {
    fontSize: 12,
    fontWeight: "500",
    margin: "5px 0px",
    marginLeft: 5,
    padding: 0,
  };

  function getFileExtension(filename) {
    var ext = /^.+\.([^.]+)$/.exec(filename);
    return ext == null ? "" : ext[1];
  }

  const { enqueueSnackbar } = useSnackbar();
  const ref = useRef();

  // useEffect(() => {
  //   setFileName(value?.target?.files[0]?.name);
  // }, [value]);

  const imageTypeArray = ["png", "jpg", "img", "pdf", "image", "jpeg"];
  return (
    <div
      style={{
        backgroundColor: "#F3F3F3",
        alignSelf: "center",
        height: 50,
        width: "100%",
        boxShadow: "none",
        outline: "none",
        paddingLeft: 10,
        borderRadius: 5,
        boxSizing: "border-box",
        ...style,
      }}
    >
      <p
        style={{
          ...fontStyle,
        }}
      >
        {title}
      </p>

      <div
        style={{
          height: 50,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
        }}
        onClick={() => {
          if (fileName === "") {
            ref.current.click();
          } else {
          }
        }}
      >
        <input
          style={{
            width: "100%",
            height: "100%",
            zIndex: -1,
            position: "absolute",
          }}
          type="file"
          ref={ref}
          onChange={(e) => {
            let size = parseFloat(
              e.target.files[0].size / (1024 * 1024)
            ).toFixed(2);
            if (
              imageTypeArray.includes(getFileExtension(e.target.files[0]?.name))
            ) {
              if (size <= 2) {
                setFile(e.target.files[0]);
                setFileName(e.target.files[0]?.name);
                onChange(e.target.files[0]);
              } else {
                enqueueSnackbar("Uploaded file exceeded maximum file size", {
                  variant: "error",
                });
              }
            } else {
              enqueueSnackbar("Please upload only valid file type", {
                variant: "error",
              });
            }
          }}
          accept={accept}
        />
        {fileName === "" ? (
          <>
            {/* <img
              src={UploadFileSvg}
              style={{
                width: 15,
                height: 15,
              }}
            /> */}
            {/* <p>upload</p> */}

            <p
              style={{
                ...fontStyle,
                fontWeight: "400",
              }}
            >
              Click here to upload
            </p>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <p
              style={{
                ...fontStyle,
                fontWeight: "400",
                marginRight: 10,
              }}
              title={fileName}
            >
              {fileName.length > 30 ? fileName?.slice(0, 30) + "..." : fileName}
            </p>
            <GrFormClose
              onClick={() => {
                setFile({});
                setFileName("");
                onClickRemove();
              }}
            />
          </div>
        )}
      </div>

      {isDownloadFileRequired && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {/* <img
            src={DownloadSvg}
            style={{
              width: 14,
              height: 14,
              marginTop: 5,
              cursor: "pointer",
            }}
          /> */}
          <p>download</p>

          <p
            style={{
              ...fontStyle,
              fontWeight: "400",
              cursor: "pointer",
            }}
          >
            Download sample file
          </p>
        </div>
      )}
    </div>
  );
}

export default CustomUploadField;
